<template>
    <div class="box">
      <div class="text text-gray">主辦機構</div>
      <img class="img" src="/assets/image/sponsor.png" />
    </div>

</template>

<script>

export default {
  name: "LaunchSponsor",
}
</script>

<style scoped>
.box{
  text-align: center;
}

.img{
  height: 80%;
  margin-top: 1vh;
}

.text{
  text-align: center;
  font-size: var(--ecs-font-sm);
  font-family: SimHei;
}
</style>
